import React from "react";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { Typography } from "@mui/material";
import CommonButton from "../../../component/Button";

export default function GetStarted({ handleGetStarted, isLoading }) {
  return (
    <CommonGrid2
      height={"100%"}
      display={"flex"}
      flexDirection={"column"}
      gap={"12px"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Typography variant="h1" fontSize={"45px"}>
        Welcome to Titan Data !
      </Typography>
      <Typography variant="h6" color="#7F56D9">
        Let us get to know about you and your needs.
      </Typography>
      <Typography variant="h6" fontWeight={400} color="#5B738B">
        Kindly fill out the following questionnaire to
        <br /> complete your Onboarding Process.
      </Typography>
      <CommonButton
        marginTop={"10px"}
        value={"Get Started"}
        padding={"10px"}
        width={"200px"}
        fontSize={"15px"}
        fontWeight={600}
        disabled={isLoading}
        loading={isLoading}
        onClick={handleGetStarted}
      />
    </CommonGrid2>
  );
}
